/**
 * Loads reviews from the Judge.me public widget API and returns them as plain objects.
 *
 * Usage:
 *   window.ChronoJudgeMe.fetchReviews({ shopDomain, apiToken, limit, minRating }).then(function(reviews) { ... });
 *
 * Each review: { id, rating, title, body, author, productTitle, productUrl, productHandle, photo, createdAt }
 */
(function() {
  if (window.ChronoJudgeMe) return;

  var API_BASE = 'https://api.judge.me/api/v1/widgets/all_reviews_page';
  var PER_PAGE = 25; // Judge.me caps all_reviews_page at 25 per request

  function text(el) {
    return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }

  function parseDate(raw) {
    if (!raw) return 0;
    var parsed = new Date(raw.replace(' UTC', 'Z').replace(' ', 'T'));
    return isNaN(parsed.getTime()) ? 0 : parsed.getTime();
  }

  function handleFromUrl(url) {
    var match = (url || '').match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function parseReviews(html) {
    if (!html) return [];
    var container = document.createElement('div');
    container.innerHTML = html;

    return Array.prototype.map.call(container.querySelectorAll('.jdgm-rev'), function(el) {
      var ratingEl = el.querySelector('.jdgm-rev__rating[data-score]');
      var bodyEl = el.querySelector('.jdgm-rev__body');
      var productEl = el.querySelector('.jdgm-rev__prod-link');
      var picEl = el.querySelector('.jdgm-rev__pic-link');
      var timestampEl = el.querySelector('.jdgm-rev__timestamp');
      var productUrl = productEl ? productEl.getAttribute('href') || '' : '';

      return {
        id: el.getAttribute('data-review-id') || '',
        rating: parseInt(ratingEl ? ratingEl.getAttribute('data-score') : '0', 10) || 0,
        title: text(el.querySelector('.jdgm-rev__title')),
        body: text(bodyEl),
        author: text(el.querySelector('.jdgm-rev__author')),
        productTitle: text(productEl),
        productUrl: productUrl,
        productHandle: handleFromUrl(productUrl),
        photo: picEl ? picEl.getAttribute('data-mfp-src') || picEl.getAttribute('href') || '' : '',
        createdAt: parseDate(timestampEl ? timestampEl.getAttribute('data-content') : '')
      };
    });
  }

  function readHeaderCount(headerHtml, attr) {
    var match = (headerHtml || '').match(new RegExp(attr + "=['\"]?(\\d+)"));
    return match ? parseInt(match[1], 10) : 0;
  }

  function fetchPage(options, reviewType, page) {
    var url = API_BASE
      + '?shop_domain=' + encodeURIComponent(options.shopDomain)
      + '&api_token=' + encodeURIComponent(options.apiToken)
      + '&review_type=' + reviewType
      + '&page=' + page
      + '&per_page=' + PER_PAGE;

    // Judge.me sends "max-age=1200" without "Vary: Origin". A cached copy can be stale (new or
    // hidden reviews missing for 20 min) or carry another origin's CORS header (theme editor vs
    // storefront), which makes the browser block it. Always ask the network.
    return fetch(url, { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function(response) {
        if (!response.ok) throw new Error('Judge.me request failed');
        return response.json();
      })
      .then(function(data) {
        return {
          reviews: parseReviews(data.all_reviews),
          header: data.all_reviews_header || ''
        };
      });
  }

  // Fetches every page of one review type (product or shop), up to maxCount reviews.
  function fetchType(options, reviewType, countAttr, maxCount) {
    return fetchPage(options, reviewType, 1).then(function(first) {
      var total = Math.min(readHeaderCount(first.header, countAttr), maxCount);
      var pages = Math.ceil(total / PER_PAGE);
      var requests = [];
      for (var page = 2; page <= pages; page++) {
        requests.push(fetchPage(options, reviewType, page).catch(function() { return { reviews: [] }; }));
      }
      return Promise.all(requests).then(function(rest) {
        return rest.reduce(function(all, result) {
          return all.concat(result.reviews);
        }, first.reviews);
      });
    }).catch(function() {
      return [];
    });
  }

  function fetchReviews(options) {
    var limit = options.limit || 100;
    var minRating = options.minRating || 1;

    return Promise.all([
      fetchType(options, 'product-reviews', 'data-number-of-product-reviews', limit),
      fetchType(options, 'shop-reviews', 'data-number-of-shop-reviews', limit)
    ]).then(function(results) {
      var seen = {};
      return results[0].concat(results[1])
        .filter(function(review) {
          if (!review.body && !review.title) return false;
          if (review.rating < minRating) return false;
          if (review.id && seen[review.id]) return false;
          seen[review.id] = true;
          return true;
        })
        .sort(function(a, b) {
          if (options.photosFirst && !!a.photo !== !!b.photo) return a.photo ? -1 : 1;
          return b.createdAt - a.createdAt;
        })
        .slice(0, limit);
    });
  }

  window.ChronoJudgeMe = {
    fetchReviews: fetchReviews
  };
})();
